import { render, staticRenderFns } from "./BtnChangePerspective.vue?vue&type=template&id=0afcf66c"
import script from "./BtnChangePerspective.vue?vue&type=script&lang=js"
export * from "./BtnChangePerspective.vue?vue&type=script&lang=js"
import style0 from "./BtnChangePerspective.vue?vue&type=style&index=0&id=0afcf66c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports